module.exports = __webpack_public_path__ + "static/media/chaturbate.bb1dd47d.png";